document.addEventListener('readystatechange', function () {
  const okendoScript = document.querySelector('script[data-oke-metafield-data]');
  const okendoData = JSON.parse(okendoScript.innerHTML);

  if (okendoData.reviewCount == 0) {
    let okendoElement = document.querySelector('.oke-sr-count');
    okendoElement.innerHTML = '(Be the first to review!)';
    okendoElement.classList.add('underline');
  }
});
